import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';
import Select from 'components/@common/Inputs/Select';
import { useField } from 'formik';
import { DISPLAY_BY_OPTIONS } from '../../../utils/report-param-utils';

type Props = {
  name?: string;
} & React.ComponentProps<typeof Select>;

const DisplayByField: React.FC<Props> = ({ name = 'displayBy', ...props }) => {
  const { t } = useTranslation('Reports');
  const [field, meta] = useField(name);

  return (
    <Select
      label={t('Display By')}
      placeholder={t('Display By')}
      size="small"
      inputProps={{ 'aria-label': t('Display By') }}
      {...field}
      {...props}
      error={!!meta.error && meta.touched}
    >
      {DISPLAY_BY_OPTIONS.map(option => (
        <MenuItem key={`${option.value}-option-display-by`} value={option.value}>
          {option.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default DisplayByField;
